<template>
  <div class="container">

    <!-- <div class="head" v-show="payover==0">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>{{title}}</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div> -->

    <div class="head" v-show="payover==0">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>{{title}}</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>


    <div class="sell_rserves_hpage" v-show="payover==0">
      <div class="sell_rserves_hpage_fit_order">
        <div class="sell_rserves_hpage_fit_order_info sell_rserves_hpage_fit_order_top sell_bb_rserves_hpage_fit_order_top">
          <div class="sell_rserves_hpage_fit_order_info_block">
            <div class="sell_rserves_hpage_fit_order_info_block_myinfo">
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_title">预约类型</div>
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_value">沸健身 (高端酒店游泳健身)</div>
              <div class="clearboth"></div>
            </div>
            <div class="sell_rserves_hpage_fit_order_info_block_myinfo">
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_title">日期</div>
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_value">{{info.week}}&nbsp;&nbsp;{{info.day}}</div>
              <div class="clearboth"></div>
            </div>
            <div class="sell_rserves_hpage_fit_order_info_block_myinfo">
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_title">到店时间</div>
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_value_arriveTime" @click="vt_showSelectPickTime()">{{vt_showSelectPickTimeTXT}}<label></label></div>
              <div class="clearboth"></div>
            </div>
            <div class="sell_rserves_hpage_fit_order_info_block_myinfo">
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_title">姓名</div>
              <input class="sell_rserves_hpage_fit_order_info_block_myinfo_value" type="text" maxlength="20" v-model="sell_username" placeholder="务必填写真实姓名, 入场需出示身份证" style="color: #F7B500;"  />
              <div class="clearboth"></div>
            </div>
            <div class="sell_rserves_hpage_fit_order_info_block_myinfo">
              <div class="sell_rserves_hpage_fit_order_info_block_myinfo_title">手机号</div>
              <input type="tel"maxlength="11" v-model="sell_phone" placeholder="务必填写真实手机号" class="sell_rserves_hpage_fit_order_info_block_myinfo_value" style="color: #F7B500;" />
              <div class="clearboth"></div>
            </div>
          </div>
        </div>
        <!-- 价格 -->
        <div v-if="false" class="sell_rserves_hpage_fit_order_price rserves_hpage_fit_order_priceS">
          <div class="sell_rserves_hpage_fit_order_price_block">
            <van-row class="sell_rserves_hpage_fit_order_price_block_item" style="border: none;">
              <van-col span="12" class="sell_rserves_hpage_fit_order_price_block_item_title">
                价格
              </van-col>
              <van-col span="12" class="sell_rserves_hpage_fit_order_price_block_item_cont">
                <div class="sell_rserves_hpage_fit_order_price_block_viprice sell_rserves_hpage_fit_order_price_block_vipriceB">¥{{info.other_fee_sel}}/人</div>
              </van-col>
            </van-row>
          </div>
        </div>
				
				<div class="te1">
					<div class="te11">是否选择发送短信</div>
					<div class="te12">
						<div @click="issms(1)" :class="[{'te1212':is_sms==1},'te121']">是</div>
						<div @click="issms(2)" :class="[{'te1212':is_sms==2},'te121']">否</div>
					</div>
				</div>
				
        <div class="yuandtt_booktips">
          <div class="yuandtt_booktips_block" v-html="stadiumInfo.book_tip"></div>
        </div>
        <div class="sell_rserves_hpage_fit_order_submit">
          <!-- submit_btn -->
          <div :class="[{'submit_faile':submit_btn=='预约已满'},'rserves_hpage_fit_order_submit_btn']" @click="rserves_submit_order()">{{submit_btn}}(剩余{{stock}}位)</div>
          <!-- <div class="rserves_hpage_fit_order_submit_tips">
            退订说明：参与秒杀活动的订单均不可退订
          </div> -->
        </div>
        <div class="sell_seat"></div>
      </div>
    </div>

    <div class="head" v-show="payover==1">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>支付成功</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div class="vision_payresult" v-show="payover==1">
      <img class="vision_payresult_img" src="../../../assets/images/base/pay_success_icon.png" />
      <div class="vision_payresult_con">
        预约成功短信已发送至手机{{sell_phone}}，请注意查收！
      </div>
      <div class="vision_payresult_tip">
        注：使用时请在酒店前台出示您的验证码和本人身份证，如有疑问可咨询400-630-5888
      </div>

      <div class="vision_payresult_btn">
        <div class="vision_payresult_btn_order" style="width: 100%;" @click="backOrder()">返回列表</div>
        <!-- <div class="vision_payresult_btn_index" @click="backHome()">返回首页</div> -->
        <div class="clearboth"></div>
      </div>
    </div>

    <div class="vt_rserves_hpage_fit_order_picktimeMask" v-show="vtRservesHpageFitOrderPicktime"></div>
    <div class="vt_rserves_hpage_fit_order_picktime" v-show="vtRservesHpageFitOrderPicktime">
      <van-datetime-picker v-model="vt_pickTimeFOrEnter" type="time" title="选择时间" :min-hour="vtpicktime_minhourse" :max-hour="vtpicktime_maxhourse" :min-minute="0" :max-minute="30" :filter="vtRservesHpageFitOrderPicktime_filter" @cancel="vtPickTimeSelectCancel" @confirm="vtPickTimeSelect" />
    </div>

  </div>
</template>

<script>
  import {
    isPhone,
    safeTel
  } from "../../../lib/utils.js"
  export default {
    data() {
      return {
        vt_showSelectPickTimeTXT:'请选择到店时间',
        sell_username:'',
        sell_phone:'',
        info:{},
        stadiumInfo:{},
        title:'斐燃生活',
        payover:0,

        vtRservesHpageFitOrderPicktime:false,
        vt_pickTimeFOrEnter:'',
        vtpicktime_minhourse:0,
        vtpicktime_maxhourse:0,
        submit_btn:'提交',
				is_sms:2,
        stock:0,
      }
    },
    created() {
      this.getInfo()
      this.loadInfo()
      // sessionStorage.setItem('ydttload','yes')
    },
    mounted() {},

    methods: {
			issms(e){
				this.is_sms=e
			},
      backOrder() {
        this.$router.go(-1)
      },
      backHome() {
        this.$router.push({
          path: "/"
        });
      },
      vt_showSelectPickTime(){
        this.vtRservesHpageFitOrderPicktime=true
      },
      vtPickTimeSelectCancel(){
        this.vtRservesHpageFitOrderPicktime=false
      },
      vtPickTimeSelect(e){
        // console.log(e)
        this.vt_showSelectPickTimeTXT=e
        this.vtRservesHpageFitOrderPicktime=false
      },
      vtRservesHpageFitOrderPicktime_filter(type, options){
        if (type === 'minute') {
          return options.filter(option => option % 30 === 0);
        }
        return options;
      },
      getInfo(){
        var $this=this
        if(localStorage.getItem("token")){
          let param = {
            token: localStorage.getItem("token")
          }
          // getInfo
          var qs = require('qs');
          let url = this.api.userApi.getInfo
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            if (result.data) {
              if(result.data.user.name==null||result.data.user.name==undefined||result.data.user.name==''){
                $this.$router.push({
                  name:'index'
                })
              }
            } else {
              $this.$toast('页面错误')
              $this.$router.push({
                name:'index'
              })
            }
          }).catch((error) => {
            $this.$toast('未知错误')
            $this.$router.push({
              name:'index'
            })
          })
        }else{
          $this.$router.push({
            name:'index'
          })
        }
      },
      loadInfo(){
        var info=JSON.parse(sessionStorage.getItem('yuandtt'))
        console.log(info)
        let week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
        info.week=week[new Date((info.day).replace(/-/g,"/")).getDay()]
        info.other_fee_sel=(info.other_fee/100).toFixed(2)
        this.info=info
        this.getStadiumDetail(info.stadium_id,info)
      },
      getStadiumDetail(stadium_id,info){
        console.log(info)
        var $this=this
        var params={
          token: localStorage.getItem("token"),
          stadium_id:stadium_id,
          // stock:1,
          date:this.info.day
        }
        // getAgentStadiumDetail
        var qs = require('qs');
        let url = this.api.userApi.getAgentStadiumDetail
        this.axios.post(url, qs.stringify(params), )
        .then((result) => {

          if(result.data.stock==0){
            $this.submit_btn='预约已满'
          }
          // console.log(result)
          result.data.origin_price_sel=(result.data.origin_price/100).toFixed(2)
          result.data.save_price_sel=parseFloat((((result.data.origin_price/100).toFixed(2))-info.other_fee_sel),10)
          $this.stadiumInfo=result.data
          $this.title=result.data.name
          $this.stock = result.data.stock
          if(result.data.business_start_time==null||result.data.business_start_time==undefined||result.data.business_start_time==''){
            $this.vtpicktime_minhourse=10
            $this.vt_pickTimeFOrEnter="10:00"
          }else{
            var stime=(result.data.business_start_time).substring(0,2)
            // // console.log(parseInt(stime,10))
            $this.vtpicktime_minhourse=parseInt(stime,10)
          }
          if(result.data.business_end_time==null||result.data.business_end_time==undefined||result.data.business_end_time==''){
            $this.vtpicktime_maxhourse=17
          }else{
            var etime=(result.data.business_end_time).substring(0,2)
            // // console.log(parseInt(etime,10))
            var litime=parseInt(etime,10) - 2
            $this.vtpicktime_maxhourse=litime
          }
        }).catch((error) => {
          $this.$toast('未知错误')
          $this.$router.push({
            name:'index'
          })
        })
      },
      rserves_submit_order(){
        if(this.submit_btn=='预约已满'){
          return
        }
        var $this=this
        if(this.vt_showSelectPickTimeTXT=='请选择到店时间'){
          this.$toast('请选择到店时间')
          return
        }
        if(this.sell_username.length==0){
          this.$toast('请输入真实姓名，以便入场')
          return
        }
        if(!isPhone(this.sell_phone)){
          this.$toast('请输入有效手机号')
          return
        }
        // var param={
        //   stadium_id:this.stadiumInfo.stadium_id,
        //   date:this.info.day,
        //   time:this.vt_showSelectPickTimeTXT,
        //   name:this.sell_username,
        //   mobile:this.sell_phone,
        //   token: localStorage.getItem("token"),
        // }

        // // console.log(param)
        // this.$dialog.confirm({
        //   message: "请确认是否要继续预约",
        //   cancelButtonText:"再逛逛",
        //   confirmButtonText:'继续预约'
        // }).then(() => {
        //   $this.$loading('正在提交~');
        //   $this.$api.seckillOtherMakeOrder(param).then(result => {
        //     // console.log(result)

        //     if(result.code==0){
        //       $this.$loading.close()
        //       $this.$toast('下单成功~');
        //       setTimeout(function(){
        //         $this.payover=1
        //       },500)
        //     }else{
        //       $this.$loading.close()
        //       $this.$toast(result.msg);

        //     }
        //   }, err => {
        //     $this.$toast('未知错误，请退出重新进入');
        //     $this.$loading.close()
        //   })
        //   //
        // }).catch(() => {
        // })
        // return
        var param={
          stadium_id:this.stadiumInfo.stadium_id,
          date:this.info.day,
          time:this.vt_showSelectPickTimeTXT,
          name:this.sell_username,
          mobile:this.sell_phone,
          token: localStorage.getItem("token"),
					is_sms:this.is_sms
        }

        this.$dialog.confirm({
          title:'温馨提示',
          message: "请确认是否要继续预约",
          cancelButtonText:"再逛逛",
          confirmButtonText:'继续预约',
          confirmButtonColor: '#544590'
        }).then(() => {
          $this.$loading('正在提交');
          // getAgentSeckillOtherMakeOrder
          var qs = require('qs');
          let url = this.api.userApi.bookAgentBookFit
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            console.log(result)
            // return
            if(!result.data){
              $this.$toast(result.msg);
              $this.$loading.close()
            }else{
              if (result.data.pay_json == ""||result.data.pay_json == undefined||result.data.pay_json == null) {
                $this.$toast('预约成功');
                $this.payover=1
                $this.$loading.close()
              } else {
                let config = JSON.parse(result.data.pay_json);
                if (typeof WeixinJSBridge == "undefined") {
                  if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,1), false);
                  } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,1));
                    document.attachEvent('onWeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,1));
                  }
                } else {
                  $this.onBridgeReady(config,result.data.order_no,1);
                }
              }
            }
          }).catch((error) => {
            $this.$toast('未知错误，请退出重新进入');
            $this.$loading.close()
          })





        }).catch(() => {

        })
      },
      onBridgeReady(config,order_no,type) {
        var $this = this
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', config,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              $this.$toast("预约成功");
              $this.$loading.close()
              $this.payover=1
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              $this.$toast("预约取消");
              $this.$loading.close()
              $this.cancelPay(order_no,type)
            } else {
              $this.$toast("支付失败,请重新支付");
              $this.$loading.close()
            }
          });
      },
      // 取消支付，释放库存
      cancelPay(order_no,type){
        var $this = this
        let param = {
          token: localStorage.getItem("token"),
          order_no:order_no,
          // type:type
        }
        // $this.$loading('正在加载~');
        // getCouponList
        var qs = require('qs');
        let url = this.api.userApi.bookCancelPay
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
        }).catch((error) => {
          // console.warn(error)
        })
      },
    },
    destroyed: function() {
    }
  }
</script>

<style lang="less" scoped="scoped">
  ::-webkit-input-placeholder { color:#F7B500; }
  ::-moz-placeholder { color:#F7B500; } /* firefox 19+ */
  :-ms-input-placeholder { color:#F7B500; } /* ie */
  input:-moz-placeholder { color:#F7B500; }
  @vm_base: 1/750*100vw;

  .sell_rserves_hpage{
    width: 100%;
    font-size: 30*@vm_base;
    .van-tabs__line{
      background-color: #444054;
    }
    .sell_rserves_hpage_fit_order{
      width: 100%;
      // height: calc(100vh - 100*@vm_base + 80*@vm_base);
      background:rgba(248,248,248,1);
      width: 100%;
      overflow: hidden;
      overflow-y: auto;
      position: relative;
      .sell_rserves_hpage_fit_order_info{
        padding: 40*@vm_base 32*@vm_base 0 32*@vm_base;
        .sell_rserves_hpage_fit_order_info_block{
          padding:32*@vm_base;
          background:rgba(255,255,255,1);
          box-shadow:0px 4px 20px 0px rgba(238,238,238,1);
          border-radius:12*@vm_base;
          .sell_rserves_hpage_fit_order_info_block_myinfo{
            width: 100%;

            .sell_rserves_hpage_fit_order_info_block_myinfo_title{
              width: 100*@vm_base;
              height: 92*@vm_base;
              line-height: 92*@vm_base;
              float: left;
              color: #999999;
              white-space: nowrap;
            }
            .sell_rserves_hpage_fit_order_info_block_myinfo_value{
              width: calc(100% - 100*@vm_base);
              height: 92*@vm_base;
              line-height: 92*@vm_base;
              float: left;
              text-align: right;
              color: #333333;
            }
            .sell_rserves_hpage_fit_order_info_block_myinfo_value_arriveTime{
              width: calc(100% - 100*@vm_base);
              height: 92*@vm_base;
              line-height: 92*@vm_base;
              float: left;
              text-align: right;
              color: #F7B500;
              label{
                display: inline-block;
                width: 12*@vm_base;
                height: 92*@vm_base;
                float: right;
                margin-left: 8*@vm_base;
                background-image: url(../../../assets/images/base/orderArrow.png);
                background-position: center;
                background-size: 12*@vm_base auto;
                background-repeat: no-repeat;
              }
            }
          }
          .van-cell__title{
            color: #999999;
            font-size: 28*@vm_base;
          }
          .van-cell__value{
            font-size: 28*@vm_base;
            color: #333333;
          }
        }
      }
    }
    .sell_rserves_hpage_fit_order_price{
      padding: 40*@vm_base 32*@vm_base 0 32*@vm_base;
      .sell_rserves_hpage_fit_order_price_block{
        padding:52*@vm_base 32*@vm_base 0 32*@vm_base;
        background:rgba(255,255,255,1);
        box-shadow:0px 4px 20px 0px rgba(238,238,238,1);
        border-radius:12*@vm_base;
        .sell_rserves_hpage_fit_order_price_block_item{
          margin-top: 0*@vm_base;
          border-bottom: 1px solid #EBEBEB;
          .sell_rserves_hpage_fit_order_price_block_item_title_st{
            padding-bottom: 32*@vm_base;
            label{
              display: inline-block;
              width: 110*@vm_base;
              height: 40*@vm_base;
              line-height: 40*@vm_base;
              font-size: 22*@vm_base;
              text-align: center;
              color: #F7B500;
              border-radius:6*@vm_base;
              border:1*@vm_base solid rgba(247,181,0,1);
            }
          }
          .sell_rserves_hpage_fit_order_price_block_item_title{
            color: #999999;
          }
          .sell_rserves_hpage_fit_order_price_block_item_cont{
            color: #333333;
            .sell_rserves_hpage_fit_order_price_block_item_cont_coupon{
              width: 100%;
              text-align: right;
              padding-bottom: 32*@vm_base;
              label{
                display: inline-block;
                float: right;
                width: 32*@vm_base;
                height: 32*@vm_base;
                margin-top: 7*@vm_base;
                background-image: url(../../../assets/images/base/orderArrow.png);
                background-size: 16*@vm_base auto;
                background-repeat: no-repeat;
                background-position: center;
              }
            }
          }
        }
        .sell_rserves_hpage_fit_order_price_block_item_title_sthead{
          margin-top: 0*@vm_base;
          border-bottom: 1px solid #EBEBEB;
          .sell_rserves_hpage_fit_order_price_block_item_title_st{
            padding-bottom: 32*@vm_base;
            label{
              display: inline-block;
              width: 110*@vm_base;
              height: 40*@vm_base;
              line-height: 40*@vm_base;
              font-size: 22*@vm_base;
              text-align: center;
              color: #F7B500;
              border-radius:6*@vm_base;
              border:1*@vm_base solid rgba(247,181,0,1);
            }
          }
          .sell_rserves_hpage_fit_order_price_block_item_title{
            color: #999999;
          }
          .sell_rserves_hpage_fit_order_price_block_item_cont{
            color: #333333;
            .sell_rserves_hpage_fit_order_price_block_item_cont_coupon{
              width: 100%;
              text-align: right;
              padding-bottom: 32*@vm_base;
              label{
                display: inline-block;
                float: right;
                width: 32*@vm_base;
                height: 32*@vm_base;
                margin-top: 7*@vm_base;
                background-image: url(../../../assets/images/base/orderArrow.png);
                background-size: 16*@vm_base auto;
                background-repeat: no-repeat;
                background-position: center;
              }
            }
          }
        }
        .sell_rserves_hpage_fit_order_price_block_viprice{
          width: 100%;
          height: 36*@vm_base;
          line-height: 36*@vm_base;
          font-size: 28*@vm_base;
          text-align: right;
          .sell_rhpfopbv_label{
            color: #F7B500;
            font-size: 38*@vm_base;
            font-weight: 600;
          }
        }
        .sell_rserves_hpage_fit_order_price_block_vipriceB{
          margin-top: 8*@vm_base;
          margin-bottom: 32*@vm_base;
          color: #333333;
          // text-decoration:line-through
        }
        .sell_rserves_hpage_fit_order_price_block_vipriceC{
          margin-top: 10*@vm_base;
          // margin-bottom: 32*@vm_base;
        }
        .sell_rserves_hpage_fit_order_price_block_totalPrice{
          height: 52*@vm_base;
          line-height: 52*@vm_base;
          margin-top: 44*@vm_base;
          .sell_rserves_hpage_fit_order_price_block_totalPrice_left{
            font-size: 28*@vm_base;
            color: #333333;
            font-weight: bold;
            background-image: url(../../../assets/images/activity/miaosha/flash.png);
            background-size: auto 57*@vm_base;
            background-position: left center;
            background-repeat: no-repeat;
            // padding-left: 32*@vm_base;
          }
          .sell_rserves_hpage_fit_order_price_block_totalPrice_right{
            text-align: right;
            font-size: 36*@vm_base;
            color: #F7B500;
            font-weight: bold;
          }
        }
        .sell_rserves_hpage_fit_order_price_block_totalPrice_save{
          height: 36*@vm_base;
          line-height: 36*@vm_base;
          margin-top: 16*@vm_base;
          // margin-top: 44*@vm_base;
          margin-bottom: 40*@vm_base;
          .sell_rserves_hpage_fit_order_price_block_totalPrice_left{
            font-size: 28*@vm_base;
            color: #333333;
            font-weight: bold;
            background-image: url(../../../assets/images/activity/miaosha/flash.png);
            background-size: 25*@vm_base 36*@vm_base;
            background-position: left center;
            background-repeat: no-repeat;
            padding-left: 32*@vm_base;
          }
          .sell_rserves_hpage_fit_order_price_block_totalPrice_right{
            text-align: right;
            font-size: 36*@vm_base;
            color: #F7B500;
            font-weight: bold;
          }
        }
        .sell_rserves_hpage_fit_order_price_block_total{
          // height: 86*@vm_base;
          padding-bottom: 32*@vm_base;
          line-height: 52*@vm_base;

          .sell_rserves_hpage_fit_order_price_block_total_align{
            text-align: right;
            font-size: 28*@vm_base;
            color: #999999;
          }
          .sell_rserves_hpage_fit_order_price_block_total_align_buycard{
            width:calc(100% + 64*@vm_base);
            margin-left: -32*@vm_base;

            text-align: right;
            background:linear-gradient(90deg,rgba(242,206,136,0) 0%,rgba(242,206,136,1) 100%);
            font-weight: bold;
            font-size:28*@vm_base;
            font-weight:500;
            color:rgba(71,71,71,1);
            .sell_rserves_hpage_fit_order_price_block_total_align_buycard_vipicon{
              display: block;
              width: 36*@vm_base;
              height: 108*@vm_base;
              background-image: url(../../../assets/images/base/nocard_icon.png);
              background-size: 28*@vm_base auto;
              background-position: center;
              background-repeat: no-repeat;
              float: right;
            }
            .sell_rserves_hpage_fit_order_price_block_total_align_buycard_viptxt{
              display: block;
              padding: 29*@vm_base 20*@vm_base 29*@vm_base 4*@vm_base;
              float: right;
              font-weight: bold;
            }
            .sell_rserves_hpage_fit_order_price_block_total_align_buycard_vipprice{
              display: block;
              font-size:42*@vm_base;
              font-weight:500;
              color:rgba(71,71,71,1);
              padding: 29*@vm_base 0;
              margin-right: 12*@vm_base;
              float: right;font-weight: bold;
            }
            .sell_rserves_hpage_fit_order_price_block_total_align_buycard_right{
              display: block;
              width: 10*@vm_base;
              height: 110*@vm_base;
              background-image: url(../../../assets/images/base/nocard_right.png);
              background-size: 10*@vm_base 25*@vm_base;
              background-position: center;
              background-repeat: no-repeat;
              float: right;
              margin-right: 32*@vm_base;
            }
          }
        }
      }
    }
    .sell_rserves_hpage_fit_order_priceS{
      margin-bottom: 248*@vm_base;
    }
    .sell_rserves_hpage_fit_order_submit{
      padding: 32*@vm_base;
      // height:208*@vm_base;
      background:rgba(255,255,255,1);
      position: fixed;
      bottom: 0;
      z-index: 5;
      width: 100%;
      .rserves_hpage_fit_order_submit_tips{
        width:100%;
        height:24*@vm_base;
        font-size:24*@vm_base;
        font-weight:400;
        color:#DF7027;
        line-height:24*@vm_base;
        margin-top: 24*@vm_base;
        text-align: center;
      }
      .rserves_hpage_fit_order_submit_btn{
        width:100%;
        height: 90*@vm_base;
        line-height: 90*@vm_base;
        text-align: center;
        font-size: 32*@vm_base;
        color: #FFFFFF;
        background:rgba(68,64,84,1);
        border-radius:12*@vm_base;
      }
      .submit_faile{
        width:100%;
        height: 90*@vm_base;
        line-height: 90*@vm_base;
        text-align: center;
        font-size: 32*@vm_base;
        color: #444054;
        // background:rgba(68,64,84,1);
        border-radius:12*@vm_base;

        background: #F3F3F3;
        // border-radius: 12px;
      }
    }
    .sell_rserves_hpage_fit_tab{
      width: 100%;
      padding: 32*@vm_base 32*@vm_base 35*@vm_base 32*@vm_base;
      background: #FFFFFF;
      // min-height: 489*@vm_base;

      .sell_rserves_hpage_fit_tab_des{
        width: 100%;
        margin-top: 32*@vm_base;
        background: #F8F8F8;
        border-radius: 6*@vm_base;
        padding: 25*@vm_base 30*@vm_base;

        font-size: 24*@vm_base;
        font-weight: 400;
        color: #333333;
      }
      .sell_rserves_hpage_fit_tab_des_Tip{
        width: 100%;
        margin-top: 18*@vm_base;
        background: #F8F8F8;
        border-radius: 6*@vm_base;
        padding: 25*@vm_base 30*@vm_base;

        font-size: 24*@vm_base;
        font-weight: 400;
        color: #333333;
      }
      .sell_rserves_hpage_fit_tab_servers{
        width: 100%;
        padding: 40*@vm_base 0*@vm_base 0*@vm_base 0*@vm_base;
        .sell_rserves_hpage_fit_tab_servers_address{
          padding-left: 32*@vm_base;
          width: 100%;
          background-image: url(../../../assets/images/base/posi.png);
          background-size: 20*@vm_base;
          background-position: left 5*@vm_base;
          background-repeat: no-repeat;
          font-size: 28*@vm_base;
          font-weight: 400;
          color: #444054;
        }
        .sell_rserves_hpage_fit_tab_servers_tips{
          padding-top: 40*@vm_base;
          width: 100%;
          div{
            width: calc(25% - 12*@vm_base);
            height: 72*@vm_base;
            line-height: 72*@vm_base;
            text-align: center;
            color: #333333;
            background:rgba(68,64,84,0.1);
            border-radius:6*@vm_base;
            float: left;
            margin-right: 12*@vm_base;
            margin-bottom: 12*@vm_base;
            font-size: 22*@vm_base;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              width: 30*@vm_base;margin-right: 5*@vm_base;
              // position: absolute;
              // top: 0;
              // left: 0;
              // margin-top: 21*@vm_base;
              // margin-left: 5*@vm_base;
            }
          }
        }
      }
    }
  }
  .yuandtt_booktips{
    width: 100%;
    padding: 32*@vm_base;
    .yuandtt_booktips_block{
      background:#EFEFEF;
      color: #333333;
      padding: 32*@vm_base;
      font-size: 28*@vm_base;
      border-radius: 12*@vm_base;
      white-space: pre-wrap;
    }
  }
  .vt_rserves_hpage_fit_order_picktimeMask{
    background:rgba(255,255,255,1);
    position: fixed;
    bottom: 0;
    z-index: 198;
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,.3);
  }
  .vt_rserves_hpage_fit_order_picktime{
    // padding: 32*@vm_base;
    background:rgba(255,255,255,1);
    position: fixed;
    bottom: 0;
    z-index: 199;
    width: 100%;
    .van-picker__confirm{
      font-size: 16px;
    }
    .van-picker__cancel{
      font-size: 16px;
    }
  }
  .vision_payresult{
    width: 100%;
    height: calc(100vh - 100*@vm_base);
    background: #FFFFFF;
    padding-top: 88*@vm_base;
    .vision_payresult_img{
      width: 83*@vm_base;
      margin: 0 auto;
      margin-bottom: 65*@vm_base;
      border-radius: 50%;
    }
    .vision_payresult_con{
      width: 100%;
      padding: 0 48*@vm_base;
      font-size: 28*@vm_base;
      color: #444054;
    }
    .vision_payresult_tip{
      color: #DF7027;
      font-size: 24*@vm_base;
      padding: 16*@vm_base 48*@vm_base;
    }
    .vision_payresult_btn{
      width: 100%;
      padding: 56*@vm_base 48*@vm_base 0 48*@vm_base;
      .vision_payresult_btn_order{
        width: calc(50% - 17*@vm_base);
        float: left;
        height:80*@vm_base;
        line-height: 80*@vm_base;
        text-align: center;
        color: #FFFFFF;
        font-size: 32*@vm_base;
        background:linear-gradient(147deg,rgba(68,64,84,1) 0%,rgba(68,64,84,1) 100%);
        border-radius:12*@vm_base;
      }
      .vision_payresult_btn_index{
        width: calc(50% - 17*@vm_base);
        float: right;
        height:80@vm_base;
        line-height: 80*@vm_base;
        text-align: center;
        border-radius:12*@vm_base;
        border:1px solid rgba(68,64,84,1);
        color: #444054;
      }
    }
  }
	
	
	
	.te1{
		width:100%;
		padding: 32*@vm_base;
		display: flex;
		justify-content: space-between;
		align-items:center;
		
		color: #333333;
		font-size: 28*@vm_base;
		
	}
	.te12{
		display: flex;
		justify-content: space-between;
		align-items:center;
	}
	.te121{
		padding: 6*@vm_base 24*@vm_base;
		margin-left: 12*@vm_base;
		border: 1*@vm_base solid #999;
		border-radius: 12*@vm_base;
	}
	.te1212{
		border: 1*@vm_base solid rgb(247, 181, 0);
		color: rgb(247, 181, 0);
	}
</style>



// WEBPACK FOOTER //
// src/components/unpublic/agent/fragentCreateOrder.vue